// import dynamic from "next/dynamic";
import Layout from "components/Layout";
import { fetchLayoutDataServer } from "lib/api/strapi-layout";
// const Cart = dynamic(() => import("components/ecommerce/cart/Cart"));
import Cart from "components/ecommerce/cart/Cart";

import { site } from "config";

// import styles from "./cart.module.scss";

export default function CartPage({ layoutData }) {
  const seo = {
    metaDescription:
      "View the items in your cart and check out with WhereNext.",
    metaTitle: "WhereNext | Cart",
    canonicalURL: `${site}/cart`,
    noindex: true,
    nofollow: true,
  };

  return (
    <Layout layoutData={layoutData} seo={seo}>
      <Cart />
    </Layout>
  );
}

export async function getStaticProps({}) {
  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();

  return {
    props: {
      layoutData,
    },
  };
}
